// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"4121":"vendor","8792":"main"}[chunkId] + "." + {"4121":"dcab04e83c6888c88177","8792":"cbce48b0240ee00b99a5"}[chunkId] + ".css";
};